<script setup>
import { inject } from 'vue'

const store = inject('store')

</script>

<template>
  <section class="bg-black" style="min-height: 100vh;">
    <div class="container">

      <h3 class="display-5 text-uppercase text-secondary text-center mb-4">DSA tuition fee</h3>

      <div class="row">
        <div class="col-sm-12 col-md-6 offset-md-3">
          <div class="table-responsive">
            <table class="table table-dark table-sm table-bordered text-secondary">
              <thead>
                <tr>
                  <th scope="col" class="h3 text-uppercase text-secondary bg-black">Fee</th>
                  <th scope="col" class="h3 text-uppercase text-secondary bg-black">Pay via net banking</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-uppercase fw-bold text-secondary bg-black">Bank</td>
                  <td class="text-uppercase fw-bold text-grey bg-black">{{ store.state.fee.bankname }}</td>
                </tr>
                <tr>
                  <td class="text-uppercase fw-bold text-secondary bg-black">Acc. Name</td>
                  <td class="text-uppercase fw-bold text-grey bg-black">{{ store.state.fee.accname }}</td>
                </tr>
                <tr>
                  <td class="text-uppercase fw-bold text-secondary bg-black">Acc. Num</td>
                  <td class="text-uppercase fw-bold text-grey bg-black">{{ store.state.fee.accnum }}</td>
                </tr>
                <tr>
                  <td class="text-uppercase fw-bold text-secondary bg-black">Sort Code</td>
                  <td class="text-uppercase fw-bold text-grey bg-black">{{ store.state.fee.sortcode }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- <pre>
        Leo is inviting you to a scheduled Zoom meeting.

        Topic: ConsoleLogLondon
        Time: This is a recurring meeting Meet anytime

        Join Zoom Meeting
        https://us02web.zoom.us/j/86887991572?pwd=STdHKysydVEweW1Tci83MHJpSnk3dz09

        Meeting ID: 868 8799 1572
        Passcode: 432234


      </pre> -->
      
    </div>
  </section>
</template>
